<template>
  <div class="well well--library">
    <LibrarySaveChangesButtons
      :saving="saving"
      :unsaved-changes="unsavedChanges"
      :just-saved="justSaved"
      :last-updated-at="lastUpdatedAt"
      :save-button-text="saveButtonText"
      @save="saveChanges"
      @discard="discardChanges"
    />

    <ul class="list-unstyled no-margin-bottom">
      <li><router-link :to="{name: 'StrategyDetailPage', params: {slugOrUuid: sourceStrategyUuid}}"><i class="fa fa-share"/> View the original strategy</router-link></li>
      <li><router-link :to="{name: 'Library'}"><i class="fa fa-arrow-left"/> Go back to library</router-link></li>
      <li><a
        role="button"
        class="text-danger"
        @click="deleteSavedStrategy"><i class="fa fa-trash"/> Move to trash</a></li>
    </ul>
  </div>
</template>

<script>
import { deleteSavedStrategyForStudent } from '@/api/library'
import LibrarySaveChangesButtons from '@/components/goals/LibrarySaveChangesButtons'
import { CONTENT_TYPES } from '@/util/access_visibility'

export default {
  name: 'SavedStrategyLibraryPanel',
  components: {
    LibrarySaveChangesButtons
  },
  props: {
    studentUuid: {
      type: String,
      required: true
    },
    studentName: {
      type: String,
      required: true
    },
    savedStrategyUuid: {
      type: String,
      required: true
    },
    sourceStrategyUuid: {
      type: String,
      required: true
    },
    lastUpdatedAt: {
      type: String,
      required: true
    },
    saving: {
      type: Boolean,
      required: true
    },
    justSaved: {
      type: Boolean,
      required: true
    },
    unsavedChanges: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    saveButtonText() {
      if (this.unsavedChanges) {
        return 'Save Changes'
      } else if (this.justSaved) {
        return 'Saved'
      } else {
        return 'No Changes Made'
      }
    }
  },
  methods: {
    deleteSavedStrategy() {
      if (confirm('Are you sure you want to remove this strategy from your library?')) {
        deleteSavedStrategyForStudent(this.savedStrategyUuid).then(() => {
          this.$router.replace({
            name: 'StudentLibraryPage',
            params: { uuid: this.studentUuid }
          })
        })
        this.$sendEvent('Clicked Move to Trash', {
          type: CONTENT_TYPES.SAVED_STRATEGY
        })
      }
    },
    saveChanges() {
      this.$emit('saveEdits')
    },
    discardChanges() {
      if (confirm('Are you sure you want to discard all changes?')) {
        this.$emit('discardEdits')
      }
    }
  }
}
</script>

<style scoped>
</style>
